import { Sparkles } from "lucide-react";
import { CATEGORIES } from "../config";

// The mysterious back of the card. Never shows the question.
export const CardBack = ({ category }) => {
  const c = CATEGORIES[category] || {};
  return (
    <div
      className="card-face card-back"
      style={{
        "--cat": c.color || "#E8A1B4",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        transform: "rotateY(0deg) translateZ(0.1px)",
        WebkitTransform: "rotateY(0deg) translateZ(0.1px)",
      }}
    >
      <div className="card-back-pattern" />
      <div className="card-back-content">
        <div className="card-back-icon">
          <Sparkles strokeWidth={1.2} size={38} />
        </div>
        <div className="card-back-label">{c.label}</div>
        <div className="card-back-hint">Touchez pour révéler</div>
      </div>
    </div>
  );
};

export default CardBack;
